import { useContext } from "react";
import {
  CartsBufferContext,
  DetectionsBufferContext,
  ReprojectionsBufferContext,
  TracksBufferContext,
} from "./controller-context";

export const useTracksBuffer = () => {
  const context = useContext(TracksBufferContext);

  if (context === undefined) {
    throw new Error(
      "useTracksBuffer must be used within a TracksBufferProvider"
    );
  }
  return context;
};

export const useCartsBuffer = () => {
  const context = useContext(CartsBufferContext);

  if (context === undefined) {
    throw new Error("useCartsBuffer must be used within a CartsBufferProvider");
  }
  return context;
};

export const useDetectionsBuffer = () => {
  const context = useContext(DetectionsBufferContext);

  if (context === undefined) {
    throw new Error(
      "useDetectionsBuffer must be used within a DetectionsBufferProvider"
    );
  }
  return context;
};

export const useReprojectionsBuffer = () => {
  const context = useContext(ReprojectionsBufferContext);

  if (context === undefined) {
    throw new Error(
      "useReprojectionsBuffer must be used within a ReprojectionsBufferProvider"
    );
  }
  return context;
};

export const useBufferController = () => {
  const [tracksBufferClient] = useContext(TracksBufferContext);
  const cartsBufferClient = useContext(CartsBufferContext);
  const detectionsBufferClient = useContext(DetectionsBufferContext);
  const projectionsBufferClient = useContext(ReprojectionsBufferContext);

  return [
    tracksBufferClient,
    cartsBufferClient,
    detectionsBufferClient,
    projectionsBufferClient,
  ] as const;
};
